import BaseListPresenter from "../../base/BaseListPresenter";
import saveAs from "../../saveAs";

class ApplicationStatusListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
  }

  componentDidMount() {
    this.findObjects();
  }

  init() {
    const user = this.view.getCurrentUser();
    this.limit = 20;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined;
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    // const keys = this.keys || this.view.getKeys() || [];
    // if (keys.length > 0) {
    //   query.keys = keys;
    // }
    return query;
  }

  async findObjects() {
    const user = this.view.getCurrentUser();
    const query = {
      where: { "applicant.id": user?.id },
    };

    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      // const objects = await this.findObjectUseCase.execute(collection, {
      //   where: { "applicant.id": user?.id },
      // });

      const [online, walkIn, reprocess] = await Promise.all([
        this.findObjectUseCase.execute("online_applicants", query),
        this.findObjectUseCase.execute("walkIn_applicants", query),
        this.findObjectUseCase.execute("reprocess_applicants", query),
      ]);

      console.log("online", online);
      console.log("walkIn", walkIn);
      console.log("reprocess", reprocess);

      this.objects = [...online, ...walkIn, ...reprocess];

      this.view.setState({ objects: this.objects });

      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  displayObjects(object) {
    this.view.setObjects(this.objects);

    this.view.navigateTo("/form/collection/" + object.id);

    this.view.setCount(this.objects.length);
  }
}

export default ApplicationStatusListPresenter;
